import React from "react";
import PageTitle from "../../layouts/PageTitle";
import AutopilotSettings from "../Dashboard/AutopilotSettings";

// AI key + per-channel style. Reuses the settings screen built earlier.
const FlowsAI = () => (
  <>
    <PageTitle activeMenu="AI & Style" motherMenu="Flows" />
    <AutopilotSettings />
  </>
);

export default FlowsAI;
